module.exports = __webpack_public_path__ + "static/media/providerfarm.5a403c07.png";